import React, { useEffect, useState } from 'react';

import { Col, Row, Form, Table } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import Menu from '../../components/Menu';

import search from '../../assets/images/search.png';
import ativo from '../../assets/images/ativo.png';
import naoAtivo from '../../assets/images/naoativo.png';
import editar from '../../assets/images/edit.png';
import excluir from '../../assets/images/delete.png';
import api from '../../services/api';
import CustomModal from '../../components/CustomModal';
import { useAlert } from 'react-alert';

import './styles.css';

const GiraAtendimento = () => {

  const [assistances, setAssistances] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [show, setShow] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [load, setLoad] = useState(false);

  const alert = useAlert();

  const getAssistances = async (search = '') => {
    try {
      const { data: { resources }
      } = await api.get('admin/assistance', { params: { search } });
      setAssistances(resources.data);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      console.log(error.response);
    }
  }


  useEffect(() => {
    getAssistances();
  }, []);
  const handleStatus = async id => {
    try {
      const { data: { resources }
      } = await api.post(`admin/assistance/${id}/status`);
      setAssistances(resources.data);
    } catch (error) {
      console.log(error);
    }
  }
  const handleDelete = async id => {
    setShow(true);
    setIdDelete(id);
  }

  const finishDelete = async () => {
    try {
      const { data: { resources }
      } = await api.delete(`admin/assistance/${idDelete}`);
      setAssistances(resources.data);
      alert.show("Dados removidos com sucesso!");
    } catch (error) {
      console.log(error);
    }
    setShow(false);

  }

  const handleSearch = (e) => {
    const value = e.target.value;
    setLoad(true);
    setSearchString(value);
    getAssistances(value);
  }
  const handleShow = () => setShow(false);

  return (
    <div className="container-fluid">

      <CustomModal show={show} handleShow={handleShow} onDelete={finishDelete} />
      <Menu />
      <div className="content">
        <Row>
          <Col sm={12} className="col-title">
            <div className="titlePages">
              <h5>Giras e Rezas</h5>
              <Link to="/gira/novo">
                <button className="btnYellow">NOVO</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form className="formSearch">
              <Form.Group controlId="formBasicEmail">
                <Form.Control type="text" placeholder="Buscar" name="search" value={searchString} onChange={handleSearch} />
                <button><img src={search} alt="Icon" /></button>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            {load &&
              <div className="load-table">
                <div className="loading"></div>
              </div>
            }
            <Table responsive>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Horário</th>
                  <th className="tableLeft">Título</th>
                  <th>Confirmações</th>
                  <th>Ativo</th>
                  <th>Editar</th>
                  <th>Excluir</th>
                </tr>
              </thead>
              <tbody>
                {assistances.map((assistance, key) => (
                  <tr key={key}>
                    <td>{assistance.date}</td>
                    <td>{assistance.hour}</td>
                    <td className="tableLeft">{assistance.title}</td>
                    <td>{assistance.confirmation}</td>
                    <td><img className="imgActive" src={assistance.status === 1 ? ativo : naoAtivo} alt="Icon" onClick={() => handleStatus(assistance.id)} />{assistance.status === 1 ? 'Sim' : 'Não'}</td>
                    <td>
                      <Link to={`/gira/edit/${assistance.id}`}>
                        <img className="imgEdit" src={editar} alt="Icon" />
                      </Link>
                    </td>
                    <td><img className="imgDelete" src={excluir} alt="Icon" onClick={() => handleDelete(assistance.id)} /></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}
export default GiraAtendimento;
